import Notification from "../../components/shared/Notification";
import request from "../../helpers/request";

export const getContacts = async () => {
  try {
    let token = localStorage.getItem("token");
    return await request(token)
      .get(`/v2/contacts`)
      .then(({ data }) => {
        return data;
      });
  } catch (error) {
    Notification(
      "Error",
      error.response.data.error ||
        error.response.data.message ||
        "Some went wrong! Please try again later!",
      "error"
    );
  }
};

export const updateContacts = async (data) => {
  try {
    let token = localStorage.getItem("token");
    return await request(token)
      .patch(`/v2/contacts/update`, data)
      .then(({ data }) => {
        Notification("Successfully updated contacts", "", "sucess");
        return data;
      });
  } catch (error) {
    Notification(
      "Error",
      error.response.data.error ||
        error.response.data.message ||
        "Some went wrong! Please try again later!",
      "error"
    );
  }
};
